<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Title</title>

  <script type="text/javascript" src="assets/js/jquery-2.1.1.min.js"></script>

</head>

<div class="nk-app-root">
  <div class="nk-main">
    <div class="nk-wrap nk-wrap-nosidebar">
      <div class="nk-content ">
        <div class="nk-split nk-split-page nk-split-md">
          <div class="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
            <div class="nk-block nk-block-middle nk-auth-body">
              <div class="pb-2">
                <img class="logo-img logo-img-lg" [src]="logo" alt="logo">
              </div>
              <div class="nk-block-head">
                <div class="nk-block-head-content">
                  <h5 class="nk-block-title">Log in with SSO</h5>
                </div>
              </div>
              <form id="form" (ngSubmit)="continueWithSSO()" class="justify-content-center">
                <div class="form-outline mt-3">
                  <input class="form-control" id="input-email" type="email" placeholder="Enter your email or username"
                         [(ngModel)]="username" name="input-email">
                </div>
                <div class="row mt-3">
                  <div class="col"></div>
                  <div class="col">
                    <button id="buttonContinue" type="submit" [disabled]="isButtonDisabled ? true : null"
                            class="btn btn-primary">Continue
                      <i class="fa fa-spinner" aria-hidden="true" [hidden]="!isLoading"></i>
                    </button>
                  </div>
                  <div class="col"></div>
                </div>

              </form>
              <div class="form-note-s2 text-left pt-4">
                <a routerLink='/login' id="return2Login"><strong>Return to login</strong></a>
              </div>
              <span [hidden]="!errorOnLogin" class="form-group badge badge-danger error-message mt-3"
                    [innerHTML]="messageError"></span>
            </div>
            <div class="nk-block nk-auth-footer">
              <div class="mt-3">
                <span class="copyright">{{ '© ' + year + ' Cancer Support Community.' | translate }}</span>
              </div>
            </div>
          </div>
          <!-- carousel -->
          <div class="nk-split-content nk-split-stretch">
            <div id="carouselExFade" class="carousel slide carousel-fade" data-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img id="image1" class="d-block w-100 rounded" alt="carousel1" [src]="image1">
                </div>
                <div class="carousel-item">
                  <img id="image2" class="d-block w-100 rounded" alt="carousel2" [src]="image2">
                </div>
                <div class="carousel-item">
                  <img id="image3" class="d-block w-100 rounded" alt="carousel3" [src]="image3">
                </div>
                <div class="carousel-item">
                  <img id="image4" class="d-block w-100 rounded" alt="carousel4" [src]="image4">
                </div>
                <div class="carousel-item">
                  <img id="image5" class="d-block w-100 rounded" alt="carousel5" [src]="image5">
                </div>
              </div>
              <!--              <a class="carousel-control-prev" href="#carouselExFade" role="button" data-bs-slide="prev">-->
              <!--                <span class="carousel-control-prev-icon" aria-hidden="true"></span>-->
              <!--                <span class="visually-hidden">Previous</span>-->
              <!--              </a>-->
              <!--              <a class="carousel-control-next" href="#carouselExFade" role="button" data-bs-slide="next">-->
              <!--                <span class="carousel-control-next-icon" aria-hidden="true"></span>-->
              <!--                <span class="visually-hidden">Next</span>-->
              <!--              </a>-->
            </div>
            <!-- carousel end -->
          </div><!-- .nk-split-content -->
        </div>
      </div>
    </div>
  </div>
</div>

</html>
